"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaItemListFilters = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var MediaContext_1 = require("../MediaContext");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var Icon_1 = require("../../Icon");
var MediaItemFilterName_1 = require("../MediaItemFilterName");
function MediaItemListFilters(_a) {
    var _b;
    var filters = _a.filters, setFilters = _a.setFilters;
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _js = mediaContext._js;
    var tabOptions = [
        {
            tab: MediaItemFilterName_1.MediaTabs.All,
            display: _js('All'),
        },
        {
            tab: MediaItemFilterName_1.MediaTabs.Images,
            display: _js('Images'),
        },
        {
            tab: MediaItemFilterName_1.MediaTabs.Documents,
            display: _js('Documents'),
        },
    ];
    if ((_b = mediaContext.mediaConstraints) === null || _b === void 0 ? void 0 : _b.videosEnabled) {
        tabOptions.splice(tabOptions.length - 1, 0, {
            tab: MediaItemFilterName_1.MediaTabs.Media,
            display: _js('Media'),
        });
    }
    var sortOptions = [
        {
            sort: MediaItemFilterName_1.MediaSorts.AZ,
            display: _js('A - Z'),
        },
        {
            sort: MediaItemFilterName_1.MediaSorts.Date,
            display: _js('Date'),
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(react_1.Flex, { justifyContent: "space-between", alignItems: "center", mb: "4", h: "50px", backgroundColor: "gray.700", px: "4", display: { base: 'none', sm: 'none', md: 'none', lg: 'flex' } },
            React.createElement(react_1.Flex, { alignItems: "center", gap: "4" },
                React.createElement(react_1.Text, { color: "gray.300" }, _js('Display:')),
                React.createElement(react_1.Flex, null, tabOptions.map(function (option) { return (React.createElement(react_1.Button, { key: option.tab, color: "white", backgroundColor: option.tab === filters.tab ? 'blue.500' : 'gray.700', border: "none", _hover: { bg: option.tab === filters.tab ? 'blue.500' : 'gray.800' }, onClick: function () { return setFilters(__assign(__assign({}, filters), { tab: option.tab })); }, "data-feature-id": "media_manager_filter_".concat(option.tab) }, option.display)); }))),
            React.createElement(react_1.Flex, { alignItems: "center", gap: "4" },
                React.createElement(react_1.Text, { color: "gray.300" }, _js('Sort By:')),
                React.createElement(react_1.Flex, null, sortOptions.map(function (option) { return (React.createElement(react_1.Button, { key: option.sort, color: "white", backgroundColor: option.sort === filters.sortBy ? 'blue.500' : 'gray.700', border: "none", _hover: { bg: option.sort === filters.sortBy ? 'blue.500' : 'gray.800' }, onClick: function () { return setFilters(__assign(__assign({}, filters), { sortBy: option.sort })); }, "data-feature-id": "media_manager_sort_".concat(option.sort) }, option.display)); })))),
        React.createElement(react_1.Flex, { justifyContent: "space-between", alignItems: "center", mb: "4", h: "50px", backgroundColor: "gray.700", display: { base: 'flex', sm: 'flex', md: 'flex', lg: 'none' } },
            React.createElement(react_1.Menu, { gutter: 0, matchWidth: true },
                React.createElement(react_1.MenuButton, { width: "50%", as: react_1.Button, backgroundColor: "gray.700", color: "white", border: "none", _hover: { bg: 'gray.800' }, _active: { bg: 'gray.800' }, h: "full", borderRadius: "0" },
                    React.createElement(react_1.Flex, { justifyContent: "flex-start", alignItems: "center", gap: "2" },
                        React.createElement(react_1.Text, null, (0, MediaItemFilterName_1.tabTitleFromFilter)()),
                        React.createElement(Icon_1.Icon, { size: "xs", type: pro_solid_svg_icons_1.faChevronDown }))),
                React.createElement(react_1.MenuList, { backgroundColor: "gray.700", border: "none", borderRadius: "0", p: "0" }, tabOptions.map(function (option) { return (React.createElement(react_1.MenuItem, { key: option.tab, backgroundColor: option.tab === filters.tab ? 'blue.500' : 'gray.700', _hover: { bg: option.tab === filters.tab ? 'blue.500' : 'gray.800' }, color: "white", justifyContent: "center", onClick: function () { return setFilters(__assign(__assign({}, filters), { tab: option.tab })); }, "data-feature-id": "media_manager_filter_".concat(option.tab) }, option.display)); }))),
            React.createElement(react_1.Menu, { gutter: 0, matchWidth: true },
                React.createElement(react_1.MenuButton, { width: "50%", as: react_1.Button, backgroundColor: "gray.700", color: "white", border: "none", _hover: { bg: 'gray.800' }, _active: { bg: 'gray.800' }, h: "full", borderRadius: "0" },
                    React.createElement(react_1.Flex, { justifyContent: "flex-end", alignItems: "center", gap: "2" },
                        React.createElement(react_1.Text, null, filters.sortBy),
                        React.createElement(Icon_1.Icon, { size: "xs", type: pro_solid_svg_icons_1.faChevronDown }))),
                React.createElement(react_1.MenuList, { backgroundColor: "gray.700", border: "none", borderRadius: "0", p: "0" }, sortOptions.map(function (option) { return (React.createElement(react_1.MenuItem, { key: option.sort, justifyContent: "center", backgroundColor: option.sort === filters.sortBy ? 'blue.500' : 'gray.700', _hover: { bg: option.sort === filters.sortBy ? 'blue.500' : 'gray.800' }, color: "white", onClick: function () { return setFilters(__assign(__assign({}, filters), { sortBy: option.sort })); }, "data-feature-id": "media_manager_sort_".concat(option.sort) }, option.display)); }))))));
}
exports.MediaItemListFilters = MediaItemListFilters;
